import axios from "axios";
import GetServerAddress from "../../../../functions/GetServerAddress";

export async function Post_Question_To_CurtAI_Medical_Overview(
  str_TypedQuestion,
  logout
) {
  console.log("ARGHHH");
  console.log(str_TypedQuestion);

  try {
    const response = await axios.post(
      GetServerAddress() + "api/staff/Post_Question_To_CurtAI_Medical_Overview",
      {
        str_TypedQuestion: str_TypedQuestion,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
          username: localStorage.getItem("Username"),
          activitylog: "No",
        },
      }
    );
    console.log("Response Data: ", response);

    // Check for specific server response indicating an invalid auth token
    if (response.data.status === 403 || response.data.status === 401) {
      logout();
      return; // Stop further execution in case of invalid auth token
    }
    //Check if nothing found
    if (response.data.data.length === 0) {
      window.alert(
        "Error, No data found matching your search. Please try again or get Admin support"
      );
    }
    //handle data set
    return response.data.data; // Update your state with the fetched data
    //Catch Errors
  } catch (error) {
    console.error("Error fetching data: ", error);
    window.alert(
      "Error Getting data, please speak to Admin if this issue persists: ",
      error
    );
  }
}
